<template>
  <div class="is-term">
    <div
      v-for="(token, index) in tokens"
      :key="'is-word-' + index"
      :data-bin-id="getBinInfo(token)"
      :class="['is-word', getBinInfo(token) && 'is-word-with-analysis']"
    >
      {{ token }}
      <div
        v-if="isWord(token)"
        class="is-word-button"
        @click="onClickInfo($event, index, token)"
      >
        &#5029;
      </div>
      <vue-simple-context-menu
        v-if="isWord(token)"
        ref="menu"
        v-bind="menuProperties(index, token)"
        v-on:option-clicked="wordAnalysisClicked"
      />
    </div>
  </div>
</template>

<script>
import VueSimpleContextMenu from "@/components/vue-simple-context-menu.vue";
import { mapGetters } from "vuex";
//const { uuid } = require("uuidv4");
import router from "../router";

const PUNCT = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~".split("");

export default {
  name: "IcelandicTerm",
  components: { VueSimpleContextMenu },
  props: {
    term: {
      default: "",
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["analysis"]),
    tokens() {
      // return this.term.split(/[ ?.,]/).filter((w) => w.length > 0);
      let ret = [];
      let ii = 0;
      while (ii < this.term.length) {
        let ch = this.term[ii++];

        if (ch == " ") continue;

        if (PUNCT.includes(ch)) {
          ret.push(ch);
        } else {
          let w = ch;
          let cont = ii < this.term.length;
          while (cont) {
            ch = this.term[ii];
            if (ch != " " && !PUNCT.includes(ch)) {
              w += ch;
              ii++;
              if (ii == this.term.length) {
                cont = false;
              }
            } else {
              cont = false;
            }
          }
          if (w != "") {
            ret.push(w);
          }
        }
      }
      return ret;
    },
  },
  methods: {
    getBinInfo(word) {
      return (this.analysis[word] || []).map((a) => a.id_bin).join(", ");
    },
    getAnalyses(word) {
      return this.analysis[word] || [];
    },
    menuProperties(index, word) {
      return {
        elementId: `icelandict-term-${index}`, // uuid(),
        options: (this.analysis[word] || []).map((a) => ({
          name: a.formdeild,
          slug: a.id_bin,
        })),
      };
    },
    onClickInfo(e, index, word) {
      e.stopPropagation();
      e.preventDefault();
      let menu = this.$refs.menu[index];
      setTimeout(function () {
        menu.showMenu(e, word);
      }, 0);
    },
    wordAnalysisClicked(data) {
      let url = "http://bin.arnastofnun.is/leit/?id=" + data.option.slug;
      let vm = router.app;
      vm.$emit("bin.arnastofnun", url);
    },
    isWord(str) {
      return str.length > 1 || !PUNCT.includes(str);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/scss/components-shared.scss";

.is-word {
  display: inline-block;
  position: relative;

  &:not(:last-child)::after {
    content: "";
    display: inline-block;
  }

  .is-word-button {
    position: absolute;
    display: none;
  }

  .is-term-popup {
    display: none;

    &.is-term-popup--visible {
      display: block;
      position: absolute;
      left: 0.5rem;
      top: 1.5rem;
      font-size: 0.9rem;
    }
  }
}

.is-term:hover .is-word-with-analysis .is-word-button {
  display: block;
  right: -4px;
  bottom: -4px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  border-radius: 50%;
  background-color: #ddd;
  text-align: center;
  cursor: default;
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
}
.is-term:hover .is-word-with-analysis:last-child .is-word-button {
  right: -10px;
}
</style>
